var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionnairesZero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Questionnaires_zero",
    "data-name": "Questionnaires zero",
    transform: "translate(-134.472 -131.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(124.831 87.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38724",
    "data-name": "Group 38724",
    transform: "translate(24.644 60.23)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1235",
    "data-name": "Ellipse 1235",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(-15.003 -16.446)",
    fill: "#a4a9b0",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1154",
    "data-name": "Ellipse 1154",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(-0.003 -1.447)",
    fill: "#a4a9b0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "copy_11_",
    "data-name": "copy (11)",
    transform: "translate(18.999 16.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31205",
    "data-name": "Path 31205",
    d: "M26.028,31.625H9.453A3.457,3.457,0,0,1,6,28.172V7.453A3.457,3.457,0,0,1,9.453,4H26.028a3.457,3.457,0,0,1,3.453,3.453V28.172A3.457,3.457,0,0,1,26.028,31.625ZM9.453,5.381A2.074,2.074,0,0,0,7.381,7.453V28.172a2.074,2.074,0,0,0,2.072,2.072H26.028A2.074,2.074,0,0,0,28.1,28.172V7.453a2.074,2.074,0,0,0-2.072-2.072Z",
    transform: "translate(1.906 1.525)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31206",
    "data-name": "Path 31206",
    d: "M5.834,29.006H4.453A3.457,3.457,0,0,1,1,25.553V3.453A3.457,3.457,0,0,1,4.453,0H21.028a3.457,3.457,0,0,1,3.453,3.453.691.691,0,0,1-1.381,0,2.074,2.074,0,0,0-2.072-2.072H4.453A2.074,2.074,0,0,0,2.381,3.453v22.1a2.074,2.074,0,0,0,2.072,2.072H5.834a.691.691,0,0,1,0,1.381Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31207",
    "data-name": "Path 31207",
    d: "M21.741,17.381H10.691a.691.691,0,1,1,0-1.381h11.05a.691.691,0,0,1,0,1.381Z",
    transform: "translate(3.431 6.1)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31208",
    "data-name": "Path 31208",
    d: "M21.741,21.381H10.691a.691.691,0,1,1,0-1.381h11.05a.691.691,0,0,1,0,1.381Z",
    transform: "translate(3.431 7.625)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31209",
    "data-name": "Path 31209",
    d: "M21.741,13.381H10.691a.691.691,0,1,1,0-1.381h11.05a.691.691,0,0,1,0,1.381Z",
    transform: "translate(3.431 4.575)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31210",
    "data-name": "Path 31210",
    d: "M21.741,9.381H10.691a.691.691,0,1,1,0-1.381h11.05a.691.691,0,0,1,0,1.381Z",
    transform: "translate(3.431 3.05)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnairesZero);
export default __webpack_public_path__ + "static/media/questionnaires-zero.3ce18e40ab9ea93f8e58d3d604f0a085.svg";
export { ForwardRef as ReactComponent };